import TaxSetups from '../consts/TaxSetups.json';

export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        address: entity.address || '',
        activatedAt: entity.activatedAt || null,
        lat: entity.lat || '',
        lng: entity.lng || '',
        phone: entity.phone || '',
        registrationNumber: entity.registrationNumber || '',
        timezone: entity.timezone || 'Asia/Jerusalem',
        currencyCode: entity.currencyCode || 'ILS',
        vatRate: entity.vatRate == null ? 0.17 : entity.vatRate,
        countryCode: entity.countryCode || 'IL',
        ownerId: entity.ownerId || null,
        posSupplierId: entity.posSupplierId || null,
        posBranchId: entity.posBranchId || null,
        posConfig: entity.posConfig || null,
        dealer: entity.dealer || 'isracard',
        dealerNumber: entity.dealerNumber || '',
        installmentsFormula: entity.installmentsFormula || null,
        industry: entity.industry || 'food',
        supportQuickPayment: entity.supportQuickPayment || false,
        supportTableOrderQr: entity.supportTableOrderQr || false,
        supportTableOrderCode: entity.supportTableOrderCode || false,
        supportCartOrderTable: entity.supportCartOrderTable || false,
        supportCartOrderPickup: entity.supportCartOrderPickup || false,
        supportCartOrderDelivery: entity.supportCartOrderDelivery || false,
        supportCompanyDelivery: entity.supportCompanyDelivery || false,
        estimatedPrepTime: entity.estimatedPrepTime || null,
        imageGuid: entity.imageGuid || undefined,
        imageUrl: entity.imageUrl || undefined,
        logoGuid: entity.logoGuid || undefined,
        thumbnail: entity.thumbnail || undefined,
        tags: entity.tags || undefined,
        sendQuickPayToPos: entity.sendQuickPayToPos || undefined,
        externalLoyaltyProgram: entity.externalLoyaltyProgram || null,
        isTerminated: entity.isTerminated || undefined,
        isSuspended: entity.isSuspended || undefined,
        salesSystemId: entity.salesSystemId || undefined,
        tenbisConfig: entity.tenbisConfig || null,
        cibusConfig: entity.cibusConfig || null,
        goodiConfig: entity.goodiConfig || null,
        multipassConfig: entity.multipassConfig || null,
        customersConfig: entity.customersConfig || null,
        taxesSetup: entity.taxesSetup || TaxSetups[0].setup,
        tippingOptions: entity.tippingOptions || null,
        onlinePaymentConfig: entity.onlinePaymentConfig || { provider: 'creditguard', dealer: 'isracard', dealerNumber: '' },
    };
};
